import React, { FC } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { variant } from 'styled-system';

import { Flex } from '../../../../layouts';
import { DrawerHeaderProps } from './types';

const StyledContainer = styled(Flex)<DrawerHeaderProps>(
  variant({
    prop: 'elevated',
    variants: {
      true: {
        boxShadow: '10',
      },
    },
  })
);

const DrawerHeader: FC<DrawerHeaderProps> = ({
  elevated = false,
  children = undefined,
}) => {
  return (
    <StyledContainer py="big" px="base" elevated={elevated}>
      <Flex flexDirection="column" position="relative" width="100%">
        {children}
      </Flex>
    </StyledContainer>
  );
};

DrawerHeader.propTypes = {
  elevated: PropTypes.bool,
  children: PropTypes.node,
};

export default DrawerHeader;
